import { AudioContext } from 'standardized-audio-context';
import { NO_CABIN, PLEXI_CABIN, GLASS_CABIN, ARCHE_CABIN } from './circles.scss';

const volumeByCabin = {
	[NO_CABIN]:			1.00,
	[PLEXI_CABIN]:	0.15,
	[GLASS_CABIN]:	0.10,
	[ARCHE_CABIN]:	0.01
};

// gainNode would be defined if Web Audio media element could be setup, otherwise html5AudioElement would be defined
let gainNode, html5AudioElement;

export const setVolumeForCabin = (selectedCabin) => {
	if (gainNode) gainNode.gain.value = volumeByCabin[selectedCabin];
	else if (html5AudioElement) html5AudioElement.volume = volumeByCabin[selectedCabin];
	else console.log('audio not setup yet');
};

export const setupMediaElement = (audioElement) => {

	try {
		// create audio context
		const audioCtx = new AudioContext(); 

		// create Web Audio sound source from HTML 5 audio element (AudioContext.createMediaElementSource => MediaElementAudioSourceNode)
		const sourceNode = audioCtx.createMediaElementSource(audioElement); 

		// create a gain node (BaseAudioContext.createGain() => GainNode)
		gainNode = audioCtx.createGain();

		// connect the source to the gain node
		sourceNode.connect(gainNode);

		// connect the gain node to the destination
		gainNode.connect(audioCtx.destination);

		// default volume 100%
		gainNode.gain.value = 1.0;
	}
	catch(error) {
		console.log('Web Audio media element could not be setup (Web Audio API might is not supported in this browser) - fallback to HTML5 audio', error);
		gainNode = undefined; // reset variable in case error after gainNode definition
		html5AudioElement = audioElement;
	}
};